import React from 'react'
import MediaLink from '../MediaLink/MediaLink';
import styles from './UnderConstruction.module.css';

const UnderConstruction = () => {
	return (
		<div className={styles.wrapper}>
			<img className={styles.pulse} src='/collage_final.jpg' alt='Under Construction' />
			<div className={styles.info}>To know more, visit <b><MediaLink type='web' link='cegtechforum.in' /></b></div>
		</div>
	)
}

export default UnderConstruction;